import * as dtos from "../dtos";
import {
  defineEmits,
  defineProps,
  ref,
  reactive,
  onMounted,
  computed,
} from "vue";
export class AgePeriod {
  minAge: number = 0;
  maxAge: number = 0;
  index: number = 0;
  periodKey: string = "";
}

export class RangeRootPeriod {
  private _min: string;
  get start(): string {
    return this.Root.data.startDate;
  }
  set start(v: string) {
    this.Root.data.startDate = v;
    this.Item.placeholder = this.start + " " + this.end;
    this.Item.label = this.Item.placeholder;
  }

  private _max: string;
  get end(): string {
    return this.Root.data.endDate;
  }
  set end(v: string) {
    this.Root.data.endDate = v;
    this.Item.placeholder = this.start + " " + this.end;
    this.Item.label = this.Item.placeholder;
  }

  Item: dtos.DynamicProperty;
  Root: dtos.AllowedAgeInPeriodPropertyValidator;
  constructor(
    root: dtos.AllowedAgeInPeriodPropertyValidator,
    v: dtos.DynamicProperty
  ) {
    this.Root = root;
    this.Item = v;
    this.Item.label = this.start + " - " + this.end;
    this.Item.placeholder = this.start + " - " + this.end;
  }
}
export class RangeRoot {
  input: dtos.DynamicProperty;
  validator: ValidatorPeriod;
  Period: RangeRootPeriod;
  constructor(v: dtos.DynamicProperty) {
    this.input = v;
    this.validator = new ValidatorPeriod();
    this.validator.range = new RangePeriod(
      this.input?.data?.startDate,
      this.input?.data?.endDate
    );

    this.validator = new ValidatorPeriod();
    this.validator.maxAge = this.input?.validators?.find(
      (v) => v.name === "allowedAgeInPeriod"
    )?.data?.maxAge;
    this.validator.minAge = this.input?.validators?.find(
      (v) => v.name === "allowedAgeInPeriod"
    )?.data?.minAge;
    this.validator.value = this.input?.validators?.some(
      (v) => v.name === "allowedAgeInPeriod"
    );

    this.Period = new RangeRootPeriod(this.addValidator(), this.input);
  }
  addValidator = (): dtos.AllowedAgeInPeriodPropertyValidator => {
    var validator = this.input.validators.find(
      (x) => x.name == "allowedAgeInPeriod"
    );
    if (!validator) {
      var period = new dtos.AllowedAgeInPeriod();
      validator = new dtos.AllowedAgeInPeriodPropertyValidator(period);
      this.input.validators.push(validator);
    }
    return validator;
  };
}

export class RangePeriod {
  start: any;
  end: any;

  constructor(s: any, e: any) {
    this.start = s;
    this.end = e;
  }
}

export class ValidatorPeriod {
  value: any;
  minAge: any;
  maxAge: any;
  name: string;
  range: RangePeriod;

  constructor() {
    this.range = new RangePeriod("", "");
    this.name = "allowedAgeInPeriod";
  }
}
